import { HttpClient } from '@angular/common/http';
import { BdtRecursoModel } from '../services/bdt/models/bdt-recurso.model';
import { GenericRepository } from './generic-repository';
import { SsoRepository } from './sso-repository';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BdtRepository extends GenericRepository<BdtRecursoModel> {
  public static recursos = new Map<number, BdtRecursoModel>();

  public constructor(
    private http: HttpClient,
    private ssoRepository: SsoRepository
  ) {
    super();
  }

  public getRecursos(tipo: number): Promise<void> {
    return new Promise((resolve, reject) => {
      if (BdtRepository.recursos.size > 0) {
        this.loadFromCache(tipo);
        resolve();
      } else {
        this.loadFromApi(tipo)
          .then(() => resolve())
          .catch(reject);
      }
    });
  }

  private loadFromCache(tipo: number): void {
    const result = Array.from(BdtRepository.recursos.values()).filter(
      (recurso) => tipo < 1 || recurso.TipoId === tipo
    );
    this.setData(result);
  }

  private loadFromApi(tipo: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http.get(this.ssoRepository.getTicket().UrlApi + '/api/bdt/recursos?include=all')
        .subscribe(
          (res: any) => {
            const result = res
              ? res
                  .map((reg: any) => new BdtRecursoModel(reg.id, reg.codigo, reg.acronimo, reg.nombre, reg.tipo_id))
                  .filter((recurso) => tipo < 1 || recurso.TipoId === tipo)
              : [];
            result.forEach((recurso) => BdtRepository.recursos.set(recurso.Id, recurso));
            this.setData(result);
            resolve();
          },
          (error) => reject(error)
        );
    });
  }

  public fetch(): void {
    throw new Error('Method not implemented.');
  }

  public save(item: BdtRecursoModel): void {
    throw new Error('Method not implemented.');
  }

  public update(item: BdtRecursoModel): void {
    throw new Error('Method not implemented.');
  }

  public delete(id: number): void {
    throw new Error('Method not implemented.');
  }
}

